import _extends from "@babel/runtime/helpers/esm/extends";
import { createElement } from "@wordpress/element";

/**
 * External dependencies
 */
import { isEmpty } from 'lodash';
/**
 * WordPress dependencies
 */

import { SelectControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
/**
 * Internal dependencies
 */

import useSetting from '../use-setting';
export default function FontFamilyControl(_ref) {
  let {
    value = '',
    onChange,
    fontFamilies,
    ...props
  } = _ref;
  const blockLevelFontFamilies = useSetting('typography.fontFamilies');

  if (!fontFamilies) {
    fontFamilies = blockLevelFontFamilies;
  }

  if (isEmpty(fontFamilies)) {
    return null;
  }

  const options = [{
    value: '',
    label: __('Default')
  }, ...fontFamilies.map(_ref2 => {
    let {
      fontFamily,
      name
    } = _ref2;
    return {
      value: fontFamily,
      label: name || fontFamily
    };
  })];
  return createElement(SelectControl, _extends({
    label: __('Font family'),
    options: options,
    value: value,
    onChange: onChange,
    labelPosition: "top"
  }, props));
}
//# sourceMappingURL=index.js.map